// Core
import React from 'react'
import clsx from 'clsx'

// Types
import type { ReactNode } from 'react'

// Styles
import classes from 'components/Onboarding/ButtonOptions/ButtonOptions.module.scss'

interface IButtonOptionsProps {
  title: ReactNode
  options: IButtonOption[]
  selectedOptions: string[]
  onClick: (value: string) => void
}

interface IButtonOption {
  value: string
  icon: ReactNode
  title: string
  description: string
}

export default function ButtonOptions({
  title,
  options,
  selectedOptions,
  onClick,
}: IButtonOptionsProps) {
  const splitOptions: IButtonOption[][] = options.reduce((acc: IButtonOption[][], option, index) => {
    if (index % 2 === 0) {
      acc.push([option])
    } else {
      acc[acc.length - 1].push(option)
    }
    return acc
  }, [])
  return (
    <>
      {title}
      {splitOptions.map((subOptions, i) => (
        <div key={`option-${i}`} className="d-flex flex-column-sm justify-content-between align-items-center">
          {subOptions.map((option, j) => (
            <button
              key={`suboption-${j}`}
              className={clsx(classes.option, selectedOptions.includes(option.value) ? classes.selected : '', 'justify-content-center')}
              onClick={() => onClick(option.value)}>
              <div>
                {option.icon}
              </div>
              <h4>{option.title}</h4>
              <p>{option.description}</p>
            </button>
          ))}
        </div>
      ))}
    </>
  )
}